import { Buttons, CancelButton, Checkbox, DeleteButton, Level, ModalCard } from '~/components';
import { useApi, useToast, useWorkspace } from '~/contexts';
import { useForm } from '~/hooks';
import { accountingProviders } from '~/lookups';
import React, { useState } from 'react';
import styled from 'styled-components';

const P = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

function DeletePaymentDialog({ payment, onDelete, onClose }) {
  const { workspace } = useWorkspace();
  const [removeFromAccounting, setRemoveFromAccounting] = useState(payment.defaultRemoveFromAccounting ?? false);
  const [{ isSubmitting }, form] = useForm();
  const toast = useToast();
  const api = useApi();

  const accountingProviderName = payment.accountingProvider && accountingProviders[payment.accountingProvider].name;

  const handleSubmit = async () => {
    form.submit();

    if (removeFromAccounting && accountingProviderName && payment.accountingSynced) {
      try {
        await api.www.workspaces(workspace.id).clientPayments(payment.id)[`removeFrom${accountingProviderName}`]();
      } catch (error) {
        toast.error(
          error.message ?? `An error has occurred. The payment has not been removed from ${accountingProviderName}.`,
        );
      }
    }

    await api.www.workspaces(workspace.id).clientPayments(payment.id).delete();

    if (onDelete) await onDelete();
    form.done();
  };

  return (
    <ModalCard title="Delete Payment" onClose={onClose}>
      <ModalCard.Body>
        <P>Are you sure you want to delete this payment?</P>
      </ModalCard.Body>

      <ModalCard.Footer>
        <Level>
          {payment.accountingSynced && accountingProviderName && (
            <Level.Item>
              <Checkbox
                label={`Remove from ${accountingProviderName}`}
                subText={payment.accountingConnectionName}
                checked={removeFromAccounting}
                onChange={() => setRemoveFromAccounting(!removeFromAccounting)}
              />
            </Level.Item>
          )}

          <Level.Item>
            <Buttons align="right">
              <CancelButton onClick={onClose}>Cancel</CancelButton>
              <DeleteButton isLoading={isSubmitting} onClick={handleSubmit}>
                Delete
              </DeleteButton>
            </Buttons>
          </Level.Item>
        </Level>
      </ModalCard.Footer>
    </ModalCard>
  );
}

export default DeletePaymentDialog;
